import i18n from "../i18n";
import {languages} from "../constants";
import {userConsts} from "../constants/users";


export const notEmptyString = str => (str && str.length > 0);

export const isEmptyString = str => str.length === 0;

export const formBody = (data = {}) => Object.keys(data).map(
    key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');

export const getFormData = (object) => {
    const formData = new FormData();
    Object.keys(object).forEach(key => formData.append(key, object[key]));
    return formData;
};


export const getBirthday = (birthday) => {
    if (birthday === "") {
        return "";
    }
    let date = new Date(birthday);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return formDate(day) + "." + formDate(month) + "." + year;
};


export const sortChamps = (champs) => {
    champs.sort(function (a, b) {
        return a.date_start - b.date_start;
    });
    return [...champs.reverse()];
};

export const sortNotifications = (notify) => {
    notify.sort(function (a,b) {
        return a.senddate - b.senddate
    });
    return [...notify.reverse()];
};

export const sortVacancies = (vacancies) => {
    vacancies.sort(function (a,b) {
        return a.datePublication - b.datePublication
    });
    return [...vacancies.reverse()];
};

export const sortChampsUser = (champs) => {
    champs.sort(function (a, b) {
        return Date.parse(a.information.date_start)- Date.parse(b.information.date_start);
    });
    return [...champs.reverse()];
};


export const sortRating = (rating) => {
    rating.sort(function (a, b) {
        return a.GeneralScore - b.GeneralScore;
    });
    return [...rating.reverse()];
};

export const addName = (data = [])  => {
    let new_data = [];
    data.forEach((member) => new_data.push({
        ...member,
        name: member.login[0] === "!" ? member.firstname.concat(" ", member.lastname == null ? "" : member.lastname) : member.login,
        formatScore: formatScore(member.GeneralScore)
    }));
    return new_data;
};


export const formDate = (item) => item.toString().length === 1 ? "0".concat(item) : item;

export const formatScore = (score) => {
    let str = score.toExponential().toString();
    let pow = str.substr(-3,3);
    let num = parseFloat(score.toExponential());

    if (num >= 1000) {
        num = Math.round(num);
    } else if(num >= 100) {
        num = num.toFixed(2);
    } else if(num >= 10) {
        num = num.toFixed(4);
    } else if(num > 0) {
        num = num.toFixed(6);
    }
    let sign ="";
    if(pow[0] === "-" || pow[0] === "+") {
        sign = pow[0];
        pow = pow.substr(-2,2)
    } else {
        sign = pow[1];
        pow = pow[2];
    }
    if(sign === "+" && pow >= 0) {
        return {
            num: num,
            sign: sign,
        }
    } else {
        return {
            num: str.substr(0,6),
            pow: pow,
            sign: sign,
        }
    }
   // console.log(pow);
   // console.log(sign);
    //return str;
};




export const translateRank = (rank) => {
    if (i18n.language === languages.RUS) {
        return rank;
    } else {
        switch (rank) {
            case userConsts.RANKS.YULING:
                return "Youngling";
            case userConsts.RANKS.PADAWAN:
                return "Padawan";
            case userConsts.RANKS.KNIGHT:
                return "Knight";
            case userConsts.RANKS.MASTER:
                return "Master";
            case userConsts.RANKS.GRAND_MASTER:
                return "Great Master";
            default:
                return rank;

        }
    }
};


export const getDate = (dat) => {
    let date = new Date(dat);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return formDate(day) + "." + formDate(month) + "." + year;
};

export const getTime = (dat) => {
    let date = new Date(dat);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    return formDate(hours) + ":" + formDate(minutes);
};


export const deleteExtraSpace = (str) => {
    return str.replace(/^\s*/, '').replace(/\s*$/, '').replace(/\n+/g, '\n\n');
};

export const formString = (data) => {
    return data < 10 ? "0".concat(data) : data;
};


// WEBPACK FOOTER //
// src/utils/common.jsx